import {
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  DISMISS_NOTIFICATION_BANNER,
} from 'actions/actionConstants'
import {
  FETCH_LANDING_PAGE,
  FETCH_MAGAZINE_ARTICLES,
  FETCH_NOTIFICATION_BANNER,
  FETCH_BANNERS,
  FETCH_FAQ,
  FETCH_LIST_BANNERS,
  FETCH_DREAM_SITE_BLOG_POSTS,
  FETCH_SITE_BANNER,
  CLEAR_SITE_BANNER,
  FETCH_BANNER_GROUP,
  FETCH_CONTENT_TAG,
} from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialContentState: App.ContentState = {
  dreamSiteBlogPosts: {},
  notifications: {},
  siteBanner: {
    data: undefined,
  },
  banners: {},
  listBanners: {},
  bannerGroup: {},
  contentTags: {},
  landingPages: {},
  landingPageErrors: {},
  magazineArticles: {
    posts: [],
    error: undefined,
    fetching: false,
  },
  faqs: {
    legal: {},
    destinationProduct: {},
  },
  fetching: false,
}

const apiCalls = apiReducerSwitch<App.ContentState>({
  [FETCH_DREAM_SITE_BLOG_POSTS]: {
    request: (state, action) => ({
      dreamSiteBlogPosts: {
        ...state.dreamSiteBlogPosts,
        [action.key]: [],
      },
    }),
    success: (state, action) => ({
      dreamSiteBlogPosts: {
        ...state.dreamSiteBlogPosts,
        [action.key]: action.data,
      },
    }),
  },
  [FETCH_LANDING_PAGE]: {
    request: (state, action) => ({
      landingPageErrors: {
        ...state.landingPageErrors,
        [action.key]: undefined,
      },
      fetching: true,
    }),
    success: (state, action) => ({
      landingPages: {
        ...state.landingPages,
        [action.key]: action.data,
      },
      fetching: false,
    }),
    failure: (state, action) => ({
      landingPageErrors: {
        ...state.landingPageErrors,
        [action.key]: action.error,
      },
      fetching: false,
    }),
  },
  [FETCH_MAGAZINE_ARTICLES]: {
    request: (state) => ({
      magazineArticles: {
        ...state.magazineArticles,
        fetching: true,
      },
    }),
    success: (state, action) => ({
      magazineArticles: {
        ...state.magazineArticles,
        posts: action.data,
        fetching: false,
      },
    }),
    failure: (state, action) => ({
      magazineArticles: {
        ...state.magazineArticles,
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_FAQ]: {
    request: (state, action) => ({
      faqs: {
        ...state.faqs,
        [action.faqType]: {
          ...state.faqs[action.faqType],
          [action.slug]: {
            fetching: true,
          },
        },
      },
    }),
    success: (state, action) => ({
      faqs: {
        ...state.faqs,
        [action.faqType]: {
          ...state.faqs[action.faqType],
          [action.slug]: {
            content: action.data,
            fetching: false,
          },
        },
      },
    }),
  },
  [FETCH_SITE_BANNER]: {
    request: (state) => ({
      siteBanner: {
        fetching: true,
        data: state.siteBanner.data,
      },
    }),
    success: (state, action) => ({
      siteBanner: {
        fetching: false,
        data: action.data,
      },
    }),
    failure: (state, action) => ({
      siteBanner: {
        fetching: false,
        data: state.siteBanner.data,
        error: action.error,
      },
    }),
  },
  [FETCH_NOTIFICATION_BANNER]: {
    success: (state, action) => ({
      notifications: {
        ...state.notifications,
        [action.slug]: action.data,
      },
    }),
  },
  [FETCH_BANNERS]: {
    success: (state, action) => ({
      banners: {
        ...state.banners,
        [action.location]: action.data,
      },
    }),
  },
  [FETCH_LIST_BANNERS]: {
    success: (state, action) => ({
      listBanners: {
        ...state.listBanners,
        [action.location]: action.data,
      },
    }),
  },
  [FETCH_BANNER_GROUP]: {
    success: (state, action) => ({
      bannerGroup: {
        ...state.bannerGroup,
        [action.slug]: action.data,
      },
    }),
  },
  [FETCH_CONTENT_TAG]: {
    success: (state, action) => ({
      contentTags: {
        ...(state.contentTags ?? {}),
        [action.slug]: action.data,
      },
    }),
  },
})

export default createAppReducer<App.ContentState>(initialContentState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [DISMISS_NOTIFICATION_BANNER]: (state, action) => {
    const notification = state.notifications[action.slug]
    if (notification) {
      return ({
        notifications: {
          ...state.notifications,
          [action.slug]: {
            ...notification,
            show: false,
          },
        },
      })
    }
  },
  [CLEAR_SITE_BANNER]: () => ({
    siteBanner: {
      data: undefined,
    },
  }),
})
